import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import RADGeneratedModels from '@/Communication/RADGeneratedModels';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import * as Convert from '@/Utility/Convert';
import Loader from '@/Utility/Loader';
import GridViewModel from '@/ViewModels/Controls/GridViewModel';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import { IOperationResultDTO } from "coreframetypings/dto";
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import CoreFrameGridViewModel from '@/ViewModels/Controls/CoreFrameGridViewModel';
import {GridColumnDefinition} from '#/DefaultViewExtensionInterfaces';
import User from '@/Model/User';

export default class DeletedUsersViewModel extends ControlViewModel {
    private GridViewModel = ComponentManager.getViewModel<typeof CoreFrameGridViewModel>('GridViewModel');
    private MessageBoxViewModel = ComponentManager.getViewModel<typeof MessageBoxViewModel>('MessageBoxViewModel');

    /**
     * Der DetailViewContext
     */
    public detailViewContext: DetailViewContext;

    /**
     * Der Text für den Button zum Übernehmen
     */
    public restoreText: string;

    /**
     * Der Tooltip-Text für den Button zum Übernehmen
     */
    public restoreTooltipText: string;

    /**
     * Die Methode zum wiederherstellen der Benutzer
     */
    public restore: Function;

    /**
     * Das ViewModel für das Grid
     */
    public grid: CoreFrameGridViewModel;

    /**
     * Das ViewModel für die DeletedUsers
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.detailViewContext = this.paramOrDefault(params.detailViewContext, null);
        this.restoreText = this.paramOrDefault('RESTORE');
        this.restoreTooltipText = this.paramOrDefault('RESTORE_TOOLTIP');
        this.restore = this.handlerOrDefault(() => {
            let selected = this.grid.selected();
            let data = this.grid.data();

            if (selected.length === 0) return;

            let requests = [];

            Loader.getInstance().show();

            for (let i = 0; i < selected.length; i++) {
                let request = ((pdoId: any) => {
                    return this.detailViewContext.callOperationUnchecked(
                        'RestoreUser',
                        [this.buildOperationParameter('System.Int64', pdoId)]
                    ).then((operationResultDTO: IOperationResultDTO) => {
                        if (this.isDisposed === false && this.validateStatus(operationResultDTO) && operationResultDTO.returnValue != false) {
                            data = _.reject(data, (user: any) => {
                                return user.PdoId == pdoId;
                            });
                            this.grid.data(data);
                        } else {
                            RADApplication.getInstance().showMessageBox(MessageBoxViewModel.createErrorMessageBox(null, 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USERRECYCLEBIN_RESTORE_FAIL'));
                        }
                    });
                })(selected[i]);

                requests.push(request);
            }

            $.when.apply($, requests).then(() => {
                Loader.getInstance().hide();
                this.detailViewContext.apply();
            });
        });

        this.grid = new this.GridViewModel({
            parentLocator: this.locator,
            locator: 'grid',
            columnDefinition: this.observableOrDefault<GridColumnDefinition[]>([
                {
                    name: 'PdoId',
                    ergName: 'PDO_ID',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: User.currentUserShouldShowPDOID()
                },
                {
                    name: 'Login',
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_USERNAME_ERGNAME',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true
                },
                {
                    name: 'Firstname',
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_VORNAME_ERGNAME',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true
                },
                {
                    name: 'Lastname',
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_NACHNAME_ERGNAME',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true
                },
                {
                    name: 'Email',
                    ergName: 'EMAIL',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true
                },
                {
                    name: 'Company',
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_COMPANY_ERGNAME',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true
                },
                {
                    name: 'DeletedAt',
                    ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_PDO_DELETED_ERGNAME',
                    field: undefined,
                    isSortable: false,
                    isFilterable: false,
                    isVisible: true,
                }
            ]),
            identity: 'PdoId',
            pageSizes: [100],
            pageSize: 100,
            page: 1
        });

        if (this.isEnabled()) {
            let operationName = 'GetDeletedUsers';
            let operationParameters = [];

            this.detailViewContext.callOperationUnchecked(
                operationName,
                operationParameters
            ).then((operationResult: IOperationResultDTO) => {
                if (this.validateStatus(operationResult)) {
                    let Root = Convert.XMLStringToObject(operationResult.returnValue) as IDeletedUsersResult;
                    let users = Root.DeletedUsers.User;

                    if (!_.isArray(users)) {
                        if (users != null) {
                            users = [users];
                        } else {
                            users = [];
                        }
                    }

                    this.grid.data(users);

                    // Bug 8952: Hier wird ohne erkennbaren Grund beim initialen Laden das GenericObject als geändert markiert. (SL)
                    //var detailViewContext = RADApplication.getInstance().currentDetailViewContext();
                    //detailViewContext.genericObject.isModified(true);
                }
            });
        }

        this.undisposeProperties.push('detailViewContext');
    }
}

interface IDeletedUsersResult {
    DeletedUsers: IDeletedUsers;
}

interface IDeletedUsers {
    User: Array<IDeletedUserInformation>;
}

interface IDeletedUserInformation {

}

ComponentManager.setViewModel('DeletedUsersViewModel', DeletedUsersViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');